import { City } from '@v2/types';
import { create } from 'zustand';

type ThemeConfigState = {
  primaryColor: string;
  cities: City[];
  tenantSlug: string;
  lightLogo: string;
  darkLogo: string;
  isTenantEnabled: boolean;
  sublogoUrl: string;
};

interface ThemeConfigSTore extends ThemeConfigState {
  resetThemeConfig: () => void;
}

export const defaultThemeConfigState: ThemeConfigState = {
  primaryColor: '#D5223C',
  cities: [],
  tenantSlug: '',
  lightLogo: 'porter-logo.png',
  darkLogo: 'porter-logo.png',
  isTenantEnabled: false,
  sublogoUrl: '',
};

export const useThemeConfigStore = create<ThemeConfigSTore>((set) => ({
  ...defaultThemeConfigState,
  resetThemeConfig: () => set(defaultThemeConfigState),
}));
